import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IUserGroup, userGroupsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';

const USER_GROUP_MODULE = 'userGroup';

const userGroupModuleInstance = getDataObjectsModule<IUserGroup>(userGroupsManager);
store.registerModule(USER_GROUP_MODULE, userGroupModuleInstance);

export { USER_GROUP_MODULE };
